module.exports = __webpack_public_path__ + "img/topTxt.c138960a.png";